import * as screens from '@core/layouts/components/menu/screens';
import { Calendar } from 'react-feather';
import paths from 'views/screens/Schedules/paths';
import permissions from 'views/screens/Schedules/permissions';
import Icon from '../../utility/icomoon';

export default [
  {
    id: 'schedules',
    title: 'schedules.scheduling',
    icon: <Calendar size={20} />,
    permissions: [permissions.schedule],
    iconName: 'noun_schedule_2522607',
    children: [
      {
        id: 'triggerListScreen',
        title: 'schedules.trigger',
        icon: <Icon size={20} icon="disparador" />,
        permissions: [permissions.schedule],
        iconName: 'disparador',
        navLink: paths.listTrigger,
        screenId: screens.TRIGGER
      }
    ]
  }
];
